import moment from 'app/modules/datetime';
import lang from 'app/lib/moment/lang/de';

moment.lang('de', lang);



// WEBPACK FOOTER //
// ./src/web/js/app/datetime.de.js